import type { ComponentProps } from "react";
import React, { Suspense } from "react";

import type { PDF } from "./PDF";

const LazyLoadedComponent = React.lazy(() => import("./PDF").then(module => ({ default: module.PDF })));

type Props = ComponentProps<typeof PDF>;

export const LazyLoadedPDF: React.FC<Props> = props => {
  return (
    <Suspense fallback={<></>}>
      <LazyLoadedComponent {...props} />
    </Suspense>
  );
};
